import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import settings from './settingsReducer';
import authentication from './authenticationReducer';
import registration from './registrationReducer';
import breadcrumb from './breadcrumbReducer';
import error from './errorReducers';
import locale from './localeReducer';
import userProfile from './userProfileReducer';
import organizationInfo from './organizationInfoReducer';
import devices from './deviceReducer';
import dashboards from './dashboardReducer';
import menu from './menuMapReducer';
import processes from './processesReducer';
import alerts from './alertReducer';
import weatherStations from './weatherStationReducer';

const reducers = {
  routing: routerReducer,
  settings: settings,
  authentication: authentication,
  registration: registration,
  breadcrumb: breadcrumb,
  error: error,
  locale: locale,
  userProfile: userProfile,
  organizationInfo: organizationInfo,
  devices: devices,
  dashboards: dashboards,
  menu: menu,
  processes: processes,
  alerts: alerts,
  weatherStations:weatherStations
};

module.exports = combineReducers(reducers);



// WEBPACK FOOTER //
// ./reducers/index.js